import { useAppSelector } from '../../../store'
import { selectLanguage } from '../slices/localizationSlice'

export default function useLocalization() {
  const language = useAppSelector(selectLanguage)
  return { language }
}
